$(document).ready(() => {
  $('.js-select2').select2({
    minimumResultsForSearch: -1,
  })
})
